module.exports = __webpack_public_path__ + "static/media/Projects.bf1efc24.png";